import _ from "lodash";
function CustomEmptyFont({ value, variant = "p",prefix='' ,className}) {
  return variant === "span" ? (
    <span className={className}>{!_.isEmpty(value) || _.isNumber(value) ? `${prefix}${value}` : `${prefix}-`}</span>
  ) : (
    <p className={className}>{!_.isEmpty(value) || _.isNumber(value) ? value : "-"}</p>
  );
}

export default CustomEmptyFont;
